import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Provider } from "app/core/models/provider.model";
import { ProviderService } from 'app/core/services/provider.service';

import { ProviderHeaderComponent } from '../../components/provider-header/provider-header.component';
import { MatIcon } from '@angular/material/icon';
import { EncounterListComponent } from '../../components/encounter-list/encounter-list.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-capture-admin-provider-encounters',
    templateUrl: './capture-admin-provider-encounters.component.html',
    styleUrls: ['./capture-admin-provider-encounters.component.scss'],
    imports: [ProviderHeaderComponent, MatIcon, EncounterListComponent, MatProgressSpinner]
})

export class CaptureAdminProviderEncountersComponent implements OnInit {
  private providerService = inject(ProviderService);
  private route = inject(ActivatedRoute);

  provider: Provider;
  loading: boolean;

  ngOnInit() {
    this.init();
  }

  fetchProviderEncounters = (paging: any, eligible: boolean) => {
    return this.providerService.encounters(this.provider.id, eligible, paging);
  }

  private init() {
    const npi = this.route.snapshot.paramMap.get('npi');
    this.loading = true;

    this.providerService.getByNpi(npi).subscribe(provider => {
      this.provider = provider;
      this.loading = false;
    });
  }
}
